import React from 'react';

export default function CommonPageTitle(props) {
  const { title = '', style, largeTitle = false } = props;

  return (
    <div className={`common-page-title ${largeTitle ? 'large':''}`}>
      <h1 style={{ ...style }}>{title}</h1>
    </div>
  );
}